<div [ngClass]="(isPhonePlanSupported && (notifyPhonesPending || notifyPhonesFailed || selectedContract?.isSuspended)) ? 'banner-hero' : 'dashboard-hero'">
  <div class="container">
    <div class="dashboard-hero-details">
      <div *ngIf="selectedContract">
        <div fxFlex fxLayout="column">
          <div class="d-flex flex-column justify-content-center">
            <div class="dashboard-header" [class.mt-4]="contracts?.length===1">
              <h1 class="mt-3 cls_mask" style="font-size:27.6112px" *ngIf="!isUserLoggedInFirstTime">
                <adp-label labelKey="Dashboard_WelcomeBack"></adp-label> {{loggedInUserFirstName}}
              </h1>
              <h1 class="mt-3 cls_mask" style="font-size:27.6112px" *ngIf="isUserLoggedInFirstTime">
                <adp-label labelKey="Dashboard_Welcome"></adp-label> {{loggedInUserFirstName}}
              </h1>
            </div>
            <div class="family-box" *ngIf="selectedContract && contracts?.length>1">
              <div class="d-flex flex-row">
                <div class="d-flex flex-row">
                  <div class="shield-icon">
                    <mat-icon [svgIcon]="'shield-gray'"></mat-icon>
                  </div>
                  <div class="d-flex flex-column">
                    <mat-form-field appearance="none">
                      <mat-select [value]="selectedContract.id" (selectionChange)="contractChange($event);">
                        <mat-option *ngFor="let contract of contracts; let i = index" [value]="contract.id">
                          <adp-label labelKey="Dashboard_SelectPlan_Title"></adp-label> {{i + 1}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <app-dashboard-data-placeholder *ngIf="!selectedContract"></app-dashboard-data-placeholder>
      <!--<app-banner-section *ngIf="selectedContract?.isSuspended" [isSuspended]="true"></app-banner-section>-->
      <app-banner-section *ngIf="!selectedContract?.isSuspended && isPhonePlanSupported" [isPhonePlanSupported]="isPhonePlanSupported" [showPendingPhonesNotification]="notifyPhonesPending" [showFailedPhonesNotification]="notifyPhonesFailed"></app-banner-section>
    </div>
  </div>
</div>
